<template>
  <div v-if="role === 'pro-retoucher'" class="uk-width-auto uk-text-center">
    <div :class="['tm-order-count uk-box-shadow-medium', { 'tm-animation-pulse': animatePulse }, orderCountClass]" @animationend="resetAnimation">
      <div>
        <md-icon>pending_actions</md-icon>  {{ children_new_orders_count }}
      </div>
    </div>
    <div class="uk-dropdown tm-dropdown tm-dropdown-left-top" data-uk-dropdown="pos: left-top; offset: 15">
      {{ getTooltipContent }}
    </div>
    {{this.isEducation}}
  </div>
</template>

<script>
export default {
  name: "CountNewOrdersPro",
  props: {
    local_page_keys: {
        type: Object,
        require: true
    },
    role:{
      type: String,
      required: true
    },
    new_orders_count:{
      type: Number,
    },
    education:{
      type: Number,
    }
  },
  data: () => ({
    intervalNewOrders: null,
    re_update_new_orders_count: null,
    animatePulse: false,
  }),
  methods: {
    async fetchCountNewOrders () {
      let data;
      let options = {};
      if(this.isEducation == 1) options['education'] = 'education';
      await this.$store.dispatch('order/countNewOrdersPro', options);
      data = await this.$store.getters['order/countNewOrdersPro'];
      this.re_update_new_orders_count = data.new_orders_count ? data.new_orders_count : 0;
    },

    resetAnimation() {
      this.animatePulse = false;
    }

  },
  async mounted() {

  },
  async created() {
    if(typeof this.children_new_orders_count == 'undefined'){
      await this.fetchCountNewOrders();
      if (this.role === 'pro-retoucher') {
        this.intervalNewOrders = setInterval(() => {
          this.fetchCountNewOrders();
        }, 10000);
      }
    }
  },
  watch: {
    new_orders_count() {
      this.animatePulse = true;
    }
  },
  computed: {
    children_new_orders_count(){
      if(this.isEducation == 1){
        this.fetchCountNewOrders();
        return this.re_update_new_orders_count;
      }
      if(this.re_update_new_orders_count) return this.re_update_new_orders_count;
      return this.new_orders_count ?? 0;
    },
    isEducation(){
      return this.education;
    },
    getTooltipContent() {
      return this.local_page_keys.tooltip_order_count_part_1 + ' ' +  this.children_new_orders_count + ' ' +  this.local_page_keys.tooltip_order_count_part_2_1 ;
    },
    orderCountClass() {
      let count = this.children_new_orders_count;
      switch (true) {
        case count >= 1 && count <= 4:
          return 'tm-order-count-yellow';
        case count >= 5 && count <= 10:
          return 'tm-order-count-orange';
        case count > 10:
          return 'tm-order-count-red';
        default:
          return '';
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalNewOrders);
  }
}
</script>
<style>
  .tm-order-count-green {
    background-color: rgba(115, 173, 33, 0.2) !important;
    border-color: rgba(115, 173, 33, 0.4) !important;
  }
  .tm-order-count-yellow {
    background-color: rgba(232, 228, 0, 0.2) !important;
    border-color: rgba(232, 228, 0, 0.4) !important;
  }
  .tm-order-count-red {
    background-color: rgba(243, 76, 63, 0.2) !important;
    border-color: rgba(243, 76, 63, 0.4) !important;
  }
  .tm-order-count-orange {
    background-color: rgba(232, 159, 0, 0.2) !important;
    border-color: rgba(232, 159, 0, 0.4) !important;
  }
</style>